import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import { HttpClient} from '@angular/common/http';
import {environment as env} from '../../../environments/environment';
import {LanguageService} from '../../services/language.service';

@Component({
  selector: 'app-rewardpoints',
  templateUrl: './rewardpoints.component.html',
  styleUrls: ['./rewardpoints.component.css']
})
export class RewardpointsComponent implements OnInit {

  uname:string;
  sajid:string;
  orddata:[] = [];
  imgurl:String;
  totalpoints:string;
  availablepoints:string;
  showLang:string;
 
  constructor(private router:Router, private route:ActivatedRoute,
     private http:HttpClient,private langObj:LanguageService) {
    this.langObj.langStr.subscribe((data)=>{
      this.showLang = data;
    });
   }

  ngOnInit(): void {
    this.imgurl = env.imgurl;
    this.uname = localStorage.getItem('sajuname');
    this.sajid = localStorage.getItem('sajid');
    this.http.get(env.apiurl+'rewards-by-user?userid='+this.sajid).subscribe(data=>{
      this.orddata = data['data'];
      this.totalpoints = data['totalpoints'];
      this.availablepoints = data['avlpoints'];

      // console.log(this.orddata);
    });
  }

}
